export default "__VITE_ASSET__DszEhiPr__";